exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delete-icon[data-v-d3bdbe78] {\n  -webkit-transform: scale(1.2);\n          transform: scale(1.2);\n}\n", ""]);

// exports
